import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=a96c7e36&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"
import style0 from "./Tip.vue?vue&type=style&index=0&id=a96c7e36&prod&lang=scss"
import style1 from "./Tip.vue?vue&type=style&index=1&id=a96c7e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96c7e36",
  null
  
)

export default component.exports